import { render, staticRenderFns } from "./C6Proposal.vue?vue&type=template&id=227e1822"
import script from "./C6Proposal.vue?vue&type=script&lang=js"
export * from "./C6Proposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports